<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <form novalidate v-on:submit.prevent>
                    <div class="modal-container modalContainer">
                        <div class="clearfix modelHeader" v-bind:class="[headerClassName ? headerClassName : 'alert alert-danger']">
                            <h5 role="alert" class="modelTitle float-left" id="commandAlertLabel">{{confirm.title}}</h5>
                            <button type="button" class="close closeBtn float-right" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modalBody">
                            <template v-if="confirm.msg">
                                {{confirm.msg}}
                            </template>
                            <template v-else>
                                <slot name="msg"/>
                            </template>
                        </div>

                        <div class="clearfix">
                            <button type="button" class="btn btn-link float-left buildingCard-body-btn btn-sm" @click="$emit('close')">
                                {{closeBtnText?closeBtnText:'Cancel'}}
                            </button>
                            <button type="button" v-bind:disabled="executeBtnDisabled" class="btn float-right buildingCard-body-btn btn-sm" v-bind:class="[executeBtnClassName ? executeBtnClassName : 'btn-danger']" @click="$emit('execute', dataToPassToModal)">
                                <span v-if="executing" class="spinner-border btnLoading" role="status">
                                    <span class="sr-only">Submitting...</span>
                                </span>
                                {{executeBtnText?executeBtnText:'Confirm'}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>
<script>
  export default {
    props: {
      dataToPassToModal: Object,
      confirm: Object,
      headerClassName: String,
      closeBtnText: String,
      executeBtnText: String,
      executeBtnDisabled: Boolean,
      executing: Boolean,
      executeBtnClassName: String,
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_modal_component.scss";
</style>